import {Vec} from '@tldraw/vec'
import {SessionType, ShapesWithProp, TldrawCommand, TldrawPatch, WhiteboardStore} from '@modules/whiteboard'
import {BaseSession} from '../BaseSession'
import {action, computed, observable} from '@api'

export class HandleSession extends BaseSession {
  type = SessionType.Handle
  @observable topLeft: number[]
  @observable shiftKey = false
  @observable initialShape: ShapesWithProp<'handles'>

  constructor(app: WhiteboardStore, public shapeId: string, public handleId: string, public commandId = 'move_handle') {
    super(app)
    const {originPoint} = app
    this.topLeft = [...originPoint]
    this.initialShape = app.getShape(shapeId)
  }

  @action start = (): TldrawPatch | undefined => {
    this.status = 'translatingHandle'
    return void null
  }

  @action update = (): TldrawPatch | undefined => {
    const {
      initialShape, shapeId,
      app, app: {getShape, currentPageId, currentPoint, shiftKey, altKey, metaKey, shapeUtilFor}
    } = this

    const shape = getShape(shapeId),
      {onHandleChange} = app.shapeUtilFor(shape)

    if (shape.isLocked) return void null

    const {handles} = shape,
      handleId = this.handleId as keyof typeof handles,
      delta = Vec.sub(currentPoint, handles[handleId].point),
      handle = handles[handleId]

    handle.point = Vec.sub(Vec.add(handles[handleId].point, delta), shape.point)

    // First update the handle's next point

    const change = onHandleChange?.(
      shape,
      {
        [handleId]: handle
      },
      {delta, shiftKey, altKey, metaKey}
    )

    if (!change) return
    _.assign(shape, change)
  }

  @action cancel = (): TldrawPatch | undefined => {
    const {
      initialShape, shapeId,
      app: {page: {shapes}}
    } = this

    shapes[shapeId] = initialShape
    return
  }

  @action complete = (): TldrawPatch | TldrawCommand | undefined => {
    const {
        initialShape, shapeId,
        app: {page, shapeUtilFor}
      } = this,
      shape = page.shapes[shapeId],
      {onSessionComplete} = shapeUtilFor(shape)

    onSessionComplete && _.assign(shape, onSessionComplete(shape))

    return
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/sessions/HandleSession/HandleSession.ts